import { useState } from "react";
import { DataTable } from "../../components/organisms/DataTable";
import { paginacion } from "../../utils/paginacion/paginacion";
import { EstudianteReprobadoCard } from "./EstudianteReprobadoCard";

const ESTUDIANTES_POR_PAGINA = 15;

export const EstudianteReprobadoList = ({ estudiantes = [], onDelete }) => {
  const [paginaActual, setPaginaActual] = useState(1);

  const {
    objetosEnPagina: estudiantesEnPagina,
    paginas,
    paginaInicial,
    paginaFinal,
  } = paginacion(paginaActual, estudiantes, ESTUDIANTES_POR_PAGINA);

  const columnas = [
    "#",
    "Nombre",
    "Apellido",
    "Teléfono",
    "Tipo de Admisión",
    "Programa",
    "Grupo",
    "Módulo Reprobado",
    "Fecha de Reprobado",
    "Opciones"
  ];

  const mostrarEstudiantes = estudiantesEnPagina.length > 0;

  return (
    <DataTable
      columnas={columnas}
      paginas={paginas}
      paginaInicial={paginaInicial}
      paginaFinal={paginaFinal}
      paginaActual={paginaActual}
      setPaginaActual={setPaginaActual}
    >
      {mostrarEstudiantes ? (
        estudiantesEnPagina.map((estudiante, i) => (
          <EstudianteReprobadoCard
            key={estudiante?.estudiante?.idEstudiante || i}
            estudiante={estudiante}
            index={(paginaActual - 1) * ESTUDIANTES_POR_PAGINA + i}
            onDelete={onDelete}
          />
        ))
      ) : (
        <tr>
          <td colSpan={columnas.length} className="text-center py-4">
            No hay estudiantes reprobados
          </td>
        </tr>
      )}
    </DataTable>
  );
};
